
<div>
  <div class="d-flex">
    <app-title-text2 class="patient-card-number-title" text="診察券番号"></app-title-text2>
    <div v-if="!isEditing" id="pills-content1">{{ oldValue }}</div>
    <div v-else id="pills-content2">
      <input
        id="customer_pet_patient_card_number"
        v-model="value"
        type="text"
        name="customer_pet[patient_card_number]"
        class="form-control content-text mb-3"
        placeholder="診察券番号を入力"
      />
      <app-normal-button
        class="active"
        title="キャンセル"
        @click.native="finishEditing()"
      ></app-normal-button>
      <app-primary-button
        class="active patient-card-number-save"
        title="保存"
        @click.native="save()"
      ></app-primary-button>
      <span class="small patient-card-number-save"
        >※ 診察券番号を編集し保存すると、編集内容が飼い主さんへ通知されます</span
      >
    </div>
    <app-link
      v-if="!isEditing"
      class="mf-2 patient-card-number-edit"
      text="編集"
      @click.native="startEditing()"
    ></app-link>
  </div>
</div>
